<template>
  <div class="flex h-full flex-col">
    <div class=""></div>

    <div class="grid-day grid h-full" :class="computedClass">
      <p v-if="data.yesterday.data.length" class="y-title day-title">Вчера</p>
      <div class="yesterday-top">
        <MainPageCardsReworkedBaseCard
          v-if="data.yesterday.data[0]"
          class="h-full"
          :data="data.yesterday.data[0]"
          disable-announce
        />
      </div>
      <div class="yesterday-bottom">
        <MainPageCardsReworkedBaseCard
          v-if="data.yesterday.data[1]"
          class="h-full"
          :data="data.yesterday.data[1]"
          disable-announce
        />
      </div>
      <p v-if="data.today.data[0]" class="tod-title day-title">В этот день</p>
      <div class="today">
        <MainPageCardsReworkedBaseCard
          v-if="data.today.data[0]"
          class="h-full"
          :data="data.today.data[0]"
        />
      </div>
      <p v-if="data.tomorrow.data.length" class="tom-title day-title">Завтра</p>
      <div class="tomorrow-top">
        <MainPageCardsReworkedBaseCard
          v-if="data.tomorrow.data[0]"
          class=""
          :data="data.tomorrow.data[0]"
          disable-announce
        />
      </div>
      <div class="tomorrow-bottom">
        <MainPageCardsReworkedBaseCard
          v-if="data.tomorrow.data[1]"
          class="col-span-full lg:col-span-2 lg:col-start-3 lg:row-start-2 xl:col-span-1 xl:col-start-4"
          :data="data.tomorrow.data[1]"
          disable-announce
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {},
  },
});
const { isMobile } = useBreakpoint();

const computedClass = computed(() => {
  if (isMobile.value) return '';
  const classes = {
    'not-bottom-yesterday': props.data?.yesterday?.data?.length === 1,
    'not-today': !props.data?.today?.data?.length,
    'not-bottom-tomorrow': props.data?.tomorrow?.data?.length === 1,
  };

  return Object.values(classes).some((val) => val) ? classes : 'full';
});
</script>
